import jwt from 'jsonwebtoken';
import api from './../api';
import { debounce } from 'lodash';

export function hasPermission(param) {
    const token = localStorage.authToken;
    if (token && jwt.decode(token).admin === true) {
        return true;
    }
    
    const encoded = localStorage.act;
    if (!encoded) {
        return false;
    }
    
    const perms = JSON.parse(atob(encoded));
    return perms[param] || false;
}

function refreshPermissions() {
    const token = localStorage.authToken;
    if (token) {
        api.users.refreshPermissions(jwt.decode(token).id)
            .then(res => {
                if (res.success == true) {
                    localStorage.act = res.result;
                }
            });
    }
}

export function belongsToCurrentUser(contentUserId) {
    const token = localStorage.authToken;
    if (token && jwt.decode(token).id === contentUserId) {
        return true;
    } else {
        return false;
    }
}

export const debouncedRefresh = debounce(refreshPermissions, 1000);


// WEBPACK FOOTER //
// ./src/utils/utils.js